import { render, staticRenderFns } from "./PredictionStatistic.vue?vue&type=template&id=690f287e&scoped=true"
import script from "./PredictionStatistic.vue?vue&type=script&lang=js"
export * from "./PredictionStatistic.vue?vue&type=script&lang=js"
import style0 from "./PredictionStatistic.vue?vue&type=style&index=0&id=690f287e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f287e",
  null
  
)

export default component.exports